import { FC } from 'react';
import { Props } from '../..';
import { IndustryArea } from '../../IndustryArea';
import { LocationArea } from '../../LocationArea';
import { OccupationArea } from '../../OccupationArea';

export const NormalModalConditions: FC<Props> = ({
  conditions,
  modalAction,
  getJobCountAtModalDisplay,
  updateJobCount,
  onChangeIsShowOverlay,
}) => {
  const { occupation, location, routeStation, industry } = conditions;
  const {
    onOpenOccupationModal,
    onOpenLocationModal,
    onOpenRouteModal,
    onOpenIndustryModal,
  } = modalAction;
  const {
    getJobCountWithoutOccupation,
    getJobCountWithoutLocationAndStation,
    getJobCountWithoutIndustry,
  } = getJobCountAtModalDisplay;

  return (
    <>
      <OccupationArea
        occupation={occupation}
        updateJobCount={updateJobCount}
        onChangeIsShowOverlay={onChangeIsShowOverlay}
        onClickOpenModal={() => {
          getJobCountWithoutOccupation();
          onOpenOccupationModal();
        }}
      />
      <LocationArea
        location={location}
        routeStation={routeStation}
        updateJobCount={updateJobCount}
        onClickOpenLocationModal={() => {
          getJobCountWithoutLocationAndStation();
          onOpenLocationModal();
        }}
        onClickOpenStationModal={() => {
          getJobCountWithoutLocationAndStation();
          onOpenRouteModal();
        }}
        onChangeIsShowOverlay={onChangeIsShowOverlay}
      />
      <IndustryArea
        industry={industry}
        updateJobCount={updateJobCount}
        onClickOpenModal={() => {
          getJobCountWithoutIndustry();
          onOpenIndustryModal();
        }}
        onChangeIsShowOverlay={onChangeIsShowOverlay}
      />
    </>
  );
};
